export default __webpack_public_path__ + "static/media/mm.1cdae683.png";